import styled from 'styled-components';
import { fontWeightBold } from '@mediahuis/chameleon-theme-wl';

export const Bold = styled.span`
  font-weight: ${fontWeightBold};
`;
